export const view09ImageOptions = {
  angle: 'view09',
  staticOptions: {
    HullColour: 1,
    Deck: 1,
    BiminiColor: 1,
    BowOption: 1,
    UpholsteryCockpit: 1,
    AnchorBow: 1,
    Galley: 1
  },
  mattes: [
    {
      option: 'Deck',
      dependency: null
    },
    {
      option: 'BowOption',
      dependency: 'UpholsteryCockpit'
    },
    {
      option: 'UpholsteryCockpit',
      dependency: 'TTop'
    },
    {
      option: 'AnchorBow',
      dependency: 'HullColour'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xpower/views/view09.js